import UpgradeTipCard from "../../components/UpgradeTipCard"
import { OscLoggedLayout } from "../../layout/OscLoggedLayout"

const Result = () => {

    return (
        <OscLoggedLayout>
            <div className="grid grid-cols-2 gap-4 p-4">
                <UpgradeTipCard />
                <UpgradeTipCard />
            </div>
        </OscLoggedLayout>
    )
}


export default Result
